export default {
  data() {
    return {
      licencePlateCountries: {
        FR: {
          nameKey: 'countries.FR',
          plateCode: 'fr',
          autoWaysCode: 'fr',
          displayIso: 'F',
          validationRegex: /^[A-Z]{2}\d{3}[A-Z]{2}$|^\d{3,4}[A-Z]{2,3}\d{2}$/,
          allowedCharsRegex: /^[A-Z0-9-\s]*$/,
          examples: ['AA-123-AA', '123 ABC 45', '1234 AB 45'],
          maxLength: 13,
        },
        ES: {
          nameKey: 'countries.ES',
          plateCode: 'es',
          autoWaysCode: 'es',
          displayIso: 'E',
          validationRegex: /^\d{4}[A-Z]{3}$/,
          allowedCharsRegex: /^[A-Z0-9\s]*$/,
          examples: ['1234 ABC'],
          maxLength: 8,
        },
        GB: {
          nameKey: 'countries.GB',
          plateCode: 'uk',
          autoWaysCode: 'uk',
          displayIso: 'GB',
          validationRegex:
            /^[A-Z]{2}\d{2}[A-Z]{3}$|^[A-Z]\d{1,3}[A-Z]{3}$|^[A-Z]{3}\d{1,3}[A-Z]$|^[A-Z]{1,3}\d{1,4}$/,
          allowedCharsRegex: /^[A-Z0-9\s]*$/,
          examples: ['AA12 ABC', 'A123 ABC', 'ABC 123A', 'ABC 1234'],
          maxLength: 8,
        },
      },
    }
  },

  computed: {
    currentCountryCode() {
      const country = this.$auth.loggedIn
        ? this.$store.$auth.user.country.iso
        : this.$store.state.country

      const detectedCountry = country || 'FR'

      return this.licencePlateCountries[detectedCountry]
        ? detectedCountry
        : 'FR'
    },

    currentLicencePlateConfig() {
      return (
        this.licencePlateCountries[this.currentCountryCode] ||
        this.licencePlateCountries.FR
      )
    },

    licencePlateDisplayIso() {
      return this.currentLicencePlateConfig.displayIso
    },

    licencePlateAutoWaysCode() {
      return this.currentLicencePlateConfig.autoWaysCode
    },

    licencePlatePlateCode() {
      return this.currentLicencePlateConfig.plateCode
    },
  },

  methods: {
    validateLicencePlate(value, countryCode = null) {
      if (!value) return false

      const country = countryCode || this.currentCountryCode
      const config = this.licencePlateCountries[country]

      if (!config) return false

      const normalized = value.replace(/[\s-]/g, '').toUpperCase()

      return config.validationRegex.test(normalized)
    },

    isCharAllowedForCountry(char, countryCode = null) {
      const country = countryCode || this.currentCountryCode
      const config = this.licencePlateCountries[country]

      if (!config) return false

      return config.allowedCharsRegex.test(char)
    },

    getLicencePlateForRequest(value) {
      if (!value) return ''

      let registration = value.replace(/[\s-]/g, '').toLowerCase()

      if (this.currentCountryCode !== 'FR') {
        registration += ',' + this.licencePlateAutoWaysCode
      }

      return registration
    },

    getLicencePlateExamples(countryCode = null) {
      const country = countryCode || this.currentCountryCode
      const config = this.licencePlateCountries[country]

      if (!config) return []

      return config.examples
    },

    getAllowedCharsRegex(countryCode = null) {
      const country = countryCode || this.currentCountryCode
      const config = this.licencePlateCountries[country]

      if (!config) return /^[A-Z0-9-\s]*$/

      return config.allowedCharsRegex
    },
  },
}
